import { getServerHelpers } from "../helpers";

export function generateUniversalLinkForCode(p: { code: string }): string {
  return `${getServerHelpers().serverConfig.universalLinkHttpBase}/${p.code.substr(0, 3)}-${p.code.substr(3, 3)}-${p.code.substr(
    6,
    3
  )}`;
}
